'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

exports.isReactElement = isReactElement;
/*
	intro : react element expand
	Author : chenchao
	Date : 2019-05-29
	Note : from react source code , thanks
*/

var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7; // judge wether a object is react element

function isReactElement(object) {
  return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && (object.$$typeof === 0xeac7 || typeof Symbol === 'function' && Symbol.for && object.$$typeof === Symbol.for('react.element'));
}